// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 새로 추가하는 앱바 스타일 */
.appBar {
  display: flex;
  align-items: center;
  height: 60px;
  width: 100%;
  padding: 0 20px;
  background-color: #FFFBF7;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.appBarLogoImage {
  height: 30px; /* 앱바 로고 크기 조정 */
}

.loginContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* 중앙에서 위로 올리기 */
  height: 100vh;
  background-color: #FFFFFF;
  padding: 20px;
  padding-top: 170px; /* 앱바 높이 고려하여 줄임 */
}

/* 메인 로고 컨테이너와 이미지 스타일 */
.mainLogoContainer {
  margin-bottom: 60px;
  padding: 10px 20px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
}

.mainLogo {
  height: 100px; /* 로고 이미지 높이 설정 - 실제 이미지에 맞게 조정 필요 */
}

/* 입력 필드와 버튼 크기 조정 */
.input {
  width: 400px; /* 너비 400px */
  height: 50px; /* 높이 50px */
  padding: 0 12px; /* 패딩 조정 */
  border: 1px solid #CCCCCC;
  border-radius: 5px;
  font-size: 16px;
  outline: none;
  box-sizing: border-box; /* 패딩과 테두리를 포함한 너비 계산 */
}

/* 로그인 버튼 그룹 (로그인 버튼 + 테스트 버튼) */
.loginButtonGroup {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 400px;
}

.loginButton {
  width: 400px;
  height: 50px;
  padding: 12px;
  background-color: #FF6F0F;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
}

/* 테스트 버튼 그룹 */
.testButtonGroup {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  gap: 3px;
}

.testButton {
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid #ccc;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.testButton.hasPlan {
  background-color: #4CAF50;
  color: white;
  border: none;
}

.testButton.noPlan {
  background-color: #F44336;
  color: white;
  border: none;
}

/* 나머지 기존 CSS 스타일 유지 */
.formGroup {
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;
}

.label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
}

.registerLink {
  display: block;
  margin-top: 20px;
  color: #666666;
  text-decoration: none;
  font-size: 14px;
  text-align: center;
}

.registerLink:hover {
  color: #3A46B1;
}

/* 로그인 페이지 링크 컨테이너 */
.loginLinks {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

/* 비밀번호 찾기 링크 */
.forgotPasswordLink {
  color: #666666;
  text-decoration: none;
  font-size: 14px;
}

.forgotPasswordLink:hover {
  color: #3A46B1;
} `, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY,EAAE,gBAAgB;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B,EAAE,gBAAgB;EAC7C,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,kBAAkB,EAAE,kBAAkB;AACxC;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa,EAAE,oCAAoC;AACrD;;AAEA,oBAAoB;AACpB;EACE,YAAY,EAAE,aAAa;EAC3B,YAAY,EAAE,YAAY;EAC1B,eAAe,EAAE,UAAU;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB,EAAE,uBAAuB;AACjD;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* 새로 추가하는 앱바 스타일 */\n.appBar {\n  display: flex;\n  align-items: center;\n  height: 60px;\n  width: 100%;\n  padding: 0 20px;\n  background-color: #FFFBF7;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n}\n\n.appBarLogoImage {\n  height: 30px; /* 앱바 로고 크기 조정 */\n}\n\n.loginContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start; /* 중앙에서 위로 올리기 */\n  height: 100vh;\n  background-color: #FFFFFF;\n  padding: 20px;\n  padding-top: 170px; /* 앱바 높이 고려하여 줄임 */\n}\n\n/* 메인 로고 컨테이너와 이미지 스타일 */\n.mainLogoContainer {\n  margin-bottom: 60px;\n  padding: 10px 20px;\n  border-radius: 5px;\n  display: flex;\n  justify-content: center;\n}\n\n.mainLogo {\n  height: 100px; /* 로고 이미지 높이 설정 - 실제 이미지에 맞게 조정 필요 */\n}\n\n/* 입력 필드와 버튼 크기 조정 */\n.input {\n  width: 400px; /* 너비 400px */\n  height: 50px; /* 높이 50px */\n  padding: 0 12px; /* 패딩 조정 */\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  font-size: 16px;\n  outline: none;\n  box-sizing: border-box; /* 패딩과 테두리를 포함한 너비 계산 */\n}\n\n/* 로그인 버튼 그룹 (로그인 버튼 + 테스트 버튼) */\n.loginButtonGroup {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 400px;\n}\n\n.loginButton {\n  width: 400px;\n  height: 50px;\n  padding: 12px;\n  background-color: #FF6F0F;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n/* 테스트 버튼 그룹 */\n.testButtonGroup {\n  display: flex;\n  flex-direction: column;\n  margin-left: 10px;\n  gap: 3px;\n}\n\n.testButton {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border-radius: 50%;\n  border: 1px solid #ccc;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.testButton.hasPlan {\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n}\n\n.testButton.noPlan {\n  background-color: #F44336;\n  color: white;\n  border: none;\n}\n\n/* 나머지 기존 CSS 스타일 유지 */\n.formGroup {\n  width: 100%;\n  max-width: 400px;\n  margin-bottom: 20px;\n}\n\n.label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 14px;\n  color: #333;\n}\n\n.registerLink {\n  display: block;\n  margin-top: 20px;\n  color: #666666;\n  text-decoration: none;\n  font-size: 14px;\n  text-align: center;\n}\n\n.registerLink:hover {\n  color: #3A46B1;\n}\n\n/* 로그인 페이지 링크 컨테이너 */\n.loginLinks {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n/* 비밀번호 찾기 링크 */\n.forgotPasswordLink {\n  color: #666666;\n  text-decoration: none;\n  font-size: 14px;\n}\n\n.forgotPasswordLink:hover {\n  color: #3A46B1;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
